import { PortalServiceDetailsResponse } from "./PortalServiceDetailsResponse";

export interface PortalServiceDetailsCategoryResponse
  extends PortalServiceDetailsResponse<PortalServiceDetailsCategoryDto[]> {}

export interface PortalServiceDetailsCustomDetailsResponse
  extends PortalServiceDetailsResponse<PortalServiceDetailsItemDto> {}

export interface PortalServiceDetailsItemDto {
  id: number;
  groupId: string;
  title: string;
  link: string;
  introText: string;
  likes: number;
  dislikes: number;
  categories: PortalServiceDetailsCategoryDto[] | null;
  photosCount: null;
  videosCount: null;
  filesCount: null;
  attr: PortalServiceDetailsAttrDto;

  languageId: number;
  contentTypeId: number;
  viewsCount: number;
  shortEnglishItemDate1: string;
  shortEnglishItemDate2: string;
  itemTime1: string;
  itemTime2: string;
  shortItemDate1: string;
  longItemDate1: string;
  shortItemDate2: string;
  longItemDate2: string;
  shortDateCreated: string;
  longDateCreated: string;
  lastUpdateDate: Date;
  shortLastUpdateDate: string;
  longLastUpdateDate: string;
  imgLink: string;
  imgLink_Prem: string;
  imgTitle: string;
  thumbnailLink: string;
  thumbnailLink_Prem: string;
  fullCDNImgLink: string;
  addToCalendarLink: string;
  exportPDFLink: string;
  exportXLSLink: string;
  qrCodeLink: string;
  index: number;
  isFirstItem: boolean;
  isLastItem: boolean;
  isPublished: boolean;
  isDeleted: boolean;
  images: any[];
  relatedItems: any[];
  enhancedRelatedItems: any[];
}

export interface PortalServiceDetailsAttrDto {
  subcategory?: PortalServiceDetailsCategoryDto | null;
  serviceCode: string;
  numberOfUsers?: null;
  numberOfApplications?: null;
  sDGGoals?: null;
  isMostUsed?: null;
  startServiceLink: null | string;
  conditionsAndRequirements: PortalServiceDetailsLookupDto[] | null;
  conditionsAndRequirements_string: string;
  requiredDocuments: PortalServiceDetailsLookupDto[];
  serviceProcess: PortalServiceDetailsLookupDto[];
  documents?: PortalServiceDetailsDocumentDto[] | null;
  relatedServices?: any[] | null;
  serviceChannels: PortalServiceDetailsLookupDto[] | null;
  audience: PortalServiceDetailsLookupDto[];
  fees: PortalServiceDetailsLookupDto[] | null;
  serviceTime: null | string;
  faq?: PortalServiceDetailsLookupDto[] | null;
  faq_string?: string;
  notes?: null;
  digitalservice?: string;
  webYoutubeLink?: string;
}

export interface PortalServiceDetailsLookupDto {
  title: string;
  text: null | string;
  index: null | string;
  hasChildren: boolean;
  children: PortalServiceDetailsLookupDto[] | null;
}

export interface PortalServiceDetailsDocumentDto {
  id: string;
  type: 'D';
  title: string;
  dlink: string;
  vlink: string;
  className: PortalServiceDetailsClassNameDto;
  extension: PortalServiceDetailsExtensionDto;
  size: number;
  sizemb: number;
  formatedsize: string;
  downloadsCount: string;
}

export enum PortalServiceDetailsClassNameDto {
  FiPDF = 'fi-pdf',
  FiWord = 'fi-word',
}

export enum PortalServiceDetailsExtensionDto {
  Doc = 'doc',
  Docx = 'docx',
  PDF = 'pdf',
}

export interface PortalServiceDetailsCategoryDto {
  id: string;
  parentId: string;
  title: string;
  className: string;
  child: any[];
}

export enum PortalServiceDetailsLanguageEnum {
  English = 1,
  Arabic = 2,
}
